import accountFormSaga from 'src/app/redux/sagas/registration/account/accountFormSaga';
import accountFormEmailSaga from 'src/app/redux/sagas/registration/account/accountFormEmailSaga';
import accountFormPasswordSaga from 'src/app/redux/sagas/registration/account/accountFormPasswordSaga';
import accountFormAgreementsRegulationsSaga from 'src/app/redux/sagas/registration/account/accountFormRegulationsSaga';
import accountFormAgreementsMarketingSaga from 'src/app/redux/sagas/registration/account/accountFormAgreementsSaga';
import confirmAccountSaga from 'src/app/redux/sagas/registration/confirmAccountSaga';
import experienceJobSaga from 'src/app/redux/sagas/registration/experience/experienceJobSaga';
import registrationSaga from 'src/app/redux/sagas/registration/registrationSaga';
import experienceEmployerSaga from 'src/app/redux/sagas/registration/experience/experienceEmployerSaga';
import experienceDateFromSaga from 'src/app/redux/sagas/registration/experience/experienceDateFromSaga';
import experienceDateToSaga from 'src/app/redux/sagas/registration/experience/experienceDateToSaga';
import experienceFormSaga from 'src/app/redux/sagas/registration/experience/experienceFormSaga';
import experienceAgreementsSaga from 'src/app/redux/sagas/registration/experience/experienceAgreementsSaga';
import experienceCountrySaga from 'src/app/redux/sagas/registration/experience/experienceCountrySaga';
import experienceCitySaga from 'src/app/redux/sagas/registration/experience/experienceCitySaga';



export default [
  ...accountFormSaga,
  ...accountFormEmailSaga,
  ...accountFormPasswordSaga,
  ...accountFormAgreementsRegulationsSaga,
  ...accountFormAgreementsMarketingSaga,
  ...confirmAccountSaga,
  ...registrationSaga,
  ...experienceJobSaga,
  ...experienceEmployerSaga,
  ...experienceDateFromSaga,
  ...experienceDateToSaga,
  ...experienceFormSaga,
  ...experienceAgreementsSaga,
  ...experienceCountrySaga,
  ...experienceCitySaga
];
